import { TAB_CONTENT_FR_FR } from "../components/tab-content/translations";
import { TABLE_EXTRACT_FR_FR } from "../components/table-extract/translations";
import { WALLET_INDICATOR_FR_FR } from "../components/wallet-indicator/translations";
import { FUTURE_ENTRIES_INDICATOR_FR_FR } from "../components/future-entries-indicator/translations";
import { FUTURE_ENTRIES_MODAL_FR_FR } from "../components/future-entries-modal/translations";
import { SAVED_ACCOUNTS_MODAL_FR_FR } from "../components/saved-accounts-modal/translations";
import { ExtractTranslations } from "./extract-pt-br";
import { WALLET_DRAWER_FR_FR } from "../components/wallet-drawer/translations";
import { LATEST_TRANSACTIONS_TABLE_FR_FR } from "../components/latest-transactions-table/translations";
import { FLOW_EXTRACT_FR_FR } from "../pages/flow/translations";
import { BLOCKED_VALUE_MODAL_FR_FR } from "../components/blocked-value-modal/translations";

export const EXTRACT_FR_FR: ExtractTranslations = {
	title: "Compte de Paiement",
	graphics: "Graphique",
	subtitle: `Suivez vos mouvements financiers clairement et comprenez vos transactions, 
		faturas e saques de forma prática.`,
	oldExtract: "Extrato Legado",
	oldExtractExpireAt: "Hasta 05/08/2025",
	walletIndicator: WALLET_INDICATOR_FR_FR,
	futureEntriesIndicator: FUTURE_ENTRIES_INDICATOR_FR_FR,
	tab: TAB_CONTENT_FR_FR,
	tableExtract: TABLE_EXTRACT_FR_FR,
	futureEntriesModal: FUTURE_ENTRIES_MODAL_FR_FR,
	walletDrawer: WALLET_DRAWER_FR_FR,
	savedAccountsModal: SAVED_ACCOUNTS_MODAL_FR_FR,
	latestTransactions: LATEST_TRANSACTIONS_TABLE_FR_FR,
	flow: FLOW_EXTRACT_FR_FR,
	blockedValueModal: BLOCKED_VALUE_MODAL_FR_FR,
	filterBy: "Filtrer par",
	typeFilter: "Tapez un filtre",
	groupBy: "Grouper par",
	groupedBy: "Groupé",
	drawer: {
		withdraw: "Retrait",
		anticipation: "Anticipation",
		ticketPayment: "Paiement de Billets",
		transferBetweenPlaces: "Transfert entre Lieux",
	},
	search: {
		emptyState: "Aucun filtre trouvé",
		clearAllTooltip: "Effacer tous les filtres",
	},
};
